import React from "react";
import Square from "./Square";

export default class Board extends React.Component {
    renderSquare(squareIndex) {
      console.log("rendering...", this.props.squares[squareIndex]);
      return <Square value={this.props.squares[squareIndex]} onClick={() => this.props.onClick(squareIndex)} />;
    }
    render() {
      return (
        <div>
          <div className="board-row">
            {this.renderSquare(0)}
            {this.renderSquare(1)}
            {this.renderSquare(2)}
          </div>
          <div className="board-row">
            {this.renderSquare(3)}
            {this.renderSquare(4)}
            {this.renderSquare(5)}
          </div>
          <div className="board-row">
            {this.renderSquare(6)}
            {this.renderSquare(7)}
            {this.renderSquare(8)}
          </div>
        </div>
      );
    }
  }